import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-child',
    templateUrl: './child.component.html',
    styleUrls: ['./child.component.css']
})
export class ChildComponent implements OnInit {

    dtOptions: DataTables.Settings = {};

    @Input() data: any[];
    @Input() employee: any[];

    constructor() { }

    ngOnInit() {
        this.dtOptions = {
            paging: false,
            ordering: false,
            

        }

        // console.log(this.data.employee);
    }

}